module.exports = __webpack_public_path__ + "assets-cabinet/img/sent_unread.e0c4db30.svg";